import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { useState } from "react";
import AccordionDetails from "@mui/material/AccordionDetails";
import CircularProgress from "@mui/material/CircularProgress";
import { toolType } from "../assets/interfaces/interfaces";

const ToolLoader = ({ messageIsLoading, toolLoaders }: { messageIsLoading: boolean; toolLoaders: Record<toolType, { completed: boolean; text: string }> }) => {
  if (!toolLoaders || Object.keys(toolLoaders).length === 0) {
    return null;
  }

  const [expanded, setExpanded] = useState<boolean>(() => {
    return messageIsLoading || false;
  });

  return (
    <div className="tool-loader my-4">
      <Accordion expanded={expanded} onChange={() => setExpanded(prevState => !prevState)} className="bg-transparent shadow-none">
        <AccordionSummary>
          {
            messageIsLoading
              ? (
                  <div className="flex items-center -ml-2">
                    <div className="flex items-center justify-center w-8 shrink-0 leading-0">
                      <CircularProgress disableShrink color="inherit" className="text-tgpt-secondary-main" size={16}></CircularProgress>
                    </div>
                    <Typography variant="body2/regular-400" className="dark:text-white text-mui-black-87">Working on it</Typography>
                    <div className={`ml-3 dark:text-white transition-transform ${expanded ? "rotate-180" : ""}`}>
                      <ExpandMoreRoundedIcon />
                    </div>
                  </div>
                )
              : (
                  <div className="flex items-center -ml-2">
                    <div className="mx-1.5 text-xl leading-0">
                      <CheckCircleRoundedIcon fontSize="inherit" className="text-success-main" />
                    </div>
                    <Typography variant="body2/regular-400" className="dark:text-white text-mui-black-87">Completed</Typography>
                    <div className={`ml-3 dark:text-white transition-transform ${expanded ? "rotate-180" : ""}`}>
                      <ExpandMoreRoundedIcon />
                    </div>
                  </div>
                )
          }
        </AccordionSummary>
        <AccordionDetails className={`flex flex-col gap-2 transition mt-1.5 ${expanded ? "opacity-100" : "opacity-0"}`}>
          {Object.entries(toolLoaders).map(([tool, { completed, text }]) => {
            return completed
              ? (
                  <div key={tool} className="flex items-center">
                    <div className="mx-1.5 text-xl leading-0">
                      <CheckCircleRoundedIcon fontSize="inherit" className="text-success-main" />
                    </div>
                    <Typography variant="body2/regular-400" className="dark:text-mui-white-70 text-mui-black-60">{text}</Typography>
                  </div>
                )
              : (
                  <div key={tool} className="flex items-center">
                    <div className="flex items-center justify-center w-8 shrink-0 leading-0">
                      <CircularProgress disableShrink color="inherit" className="text-tgpt-secondary-main animation-fast" size={16}></CircularProgress>
                    </div>
                    <Typography variant="body2/regular-400" className="dark:text-white text-mui-black-87">{text}</Typography>
                  </div>
                );
          })}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ToolLoader;
